if (!customElements.get('collapsible-text')) {
  customElements.define(
    'collapsible-text',
    class extends HTMLElement {
      constructor() {
        super();

        this.content = this.querySelector('[data-collapsible-content]');
        this.toggle = this.querySelector('[data-collapsible-toggle]');
      }

      connectedCallback() {
        this.toggle?.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick() {
        if (this.content && this.toggle)
          this.content.setAttribute(
            'data-collapsed',
            this.content?.getAttribute('data-collapsed') === 'true' ? 'false' : 'true',
          );
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleClick);
      }
    },
  );
}
